// Enum for prompt template structure types
export enum PromptTemplateStructureEnum {
    Merged = 'Merged',
    Orchestrated = 'Orchestrated'
}

// Enum for prompt template block types
export enum PromptTemplateBlockTypeEnum {
    Plain = 'Plain',
    Preprocessing = 'Preprocessing',
    Processing = 'Processing',
    Postprocessing = 'Postprocessing'
}

export enum PromptTemplateHighlightColour {
    Blue = 'Blue',
    Orange = 'Orange',
    Gray = 'Gray'
}

// Interface for prompt template blocks
export interface PromptTemplateBlock {
    id?: string;
    title: string;
    comment?: string;
    body: string;
    blockType: PromptTemplateBlockTypeEnum;
}

// Main interface for prompt templates
export interface PromptTemplate {
    id: string;
    title: string;
    description?: string;
    body: string;
    createdTime: string;
    updatedTime?: string;
    createdBy: string;
    updatedBy?: string;
    projectId: string;
    structuredOutput?: string;
    blocks?: PromptTemplateBlock[];
    currentVersion: number;
    isDraft: boolean;
    highlightColour?: PromptTemplateHighlightColour | null;
    promptTemplateStructure: PromptTemplateStructureEnum;
}

export interface PromptTemplateVersion {
    id: string;
    version: number;
    isDraft: boolean;
    createdBy: string;
    createDate: string;
    title: string;
}

export interface PromptTemplatesRouterParams {
    projectId: string;
    templateId: string;
}
